import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { PageTitle } from "@/components/layout/PageTitle";

interface AdminPageHeaderProps {
  icon: LucideIcon;
  iconClassName?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}

/** Thin wrapper kept for back-compat; renders the canonical PageTitle. */
export function AdminPageHeader({
  icon,
  iconClassName,
  title,
  description,
  actions,
}: AdminPageHeaderProps) {
  return (
    <PageTitle
      icon={icon}
      iconClassName={iconClassName ?? "h-8 w-8"}
      title={title}
      description={description}
      actions={actions}
    />
  );
}
